type ManualAdjustmentNode = {
	quantityChange?: number | null,
	product?: {
		manufacturerNumber?: string | null,
		partClass: {
			description: string,
		},
	} | null,
	createdByUser: {
		firstName?: string | null,
		lastName?: string | null,
	},
}

export default {
	name: 'Adjustment',
	render: ( ma: ManualAdjustmentNode ) => {
		if ( ma.quantityChange && ma.product ) {
			const user = ma.createdByUser
			const direction = ma.quantityChange > 0 ? 'increased' : 'decreased'
			const product = `${ma.product.manufacturerNumber} ${ma.product.partClass.description}`
			const amount = Math.abs( ma.quantityChange )

			return `${user.firstName} ${user.lastName} ${direction} quantity of ${product} by ${amount}`
		}
		return ''
	}
}
